define('modules/header/modals/select_store_modal',[
  'backbone',
  'jquery',
  '_',
  'moment',
  'text!./select_store_modal_template.html',
  'session',
], function (Backbone, $, _, moment, modal_template, session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.model = new Backbone.Model({
        stores: this.stores,
        selectedLocation: this.getActiveStoreLocation(),
      });

      this.listenTo(this.model, 'change', this.render);
    },

    hasSidebar: false,

    subViews: [],
    tagName: 'div',
    className: 'select-store-modal',
    template: _.template(modal_template),

    events: {
      'click .js-switch-store': 'switchStore',
      'change .js-stores': 'changeSelectedStore',
      'input #stores-search-field': 'onSearch',
      'click .js-store-option': 'changeSelectedStore',
      'click .js-dropbtn': 'toggleDropdown',
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    getActiveStoreLocation: function () {
      for (var i = 0; i < this.stores.length; i++) {
        if (this.stores[i].state === 'active') {
          return {
            name: this.stores[i].location_name,
            id: this.stores[i].location_id,
          };
        }
      }
      return {
        name: '',
        id: 0,
      };
    },

    changeSelectedStore: function (e) {
      var model = this.model.toJSON();
      for (var i = 0; i < model.stores.length; i++) {
        model.stores[i].state =
          model.stores[i].location_id === parseInt(e.currentTarget.id)
            ? 'active'
            : '';
      }
      this.model.set('stores', model.stores);
      this.model.set('selectedLocation', {
        id: e.currentTarget.id,
        name: e.currentTarget.getAttribute('name'),
      });
    },

    toggleDropdown: function (e) {
      e.preventDefault();
      document.getElementById('storeDropdown').classList.toggle('show');
      this.$('#stores-search-field').focus();
    },

    switchStore: function (e) {
      e.preventDefault();

      var model = this.model.toJSON();

      if (!model.selectedLocation.id) {
        return;
      }

      $.ajax({
        type: 'POST',
        url:
          session.get('apiUrl') +
          'btv/user/setlocation?locationId=' +
          model.selectedLocation.id,
        contenttype: 'application/json',
      })
        .success(
          function (data) {
            console.info(data);
            window.location.reload();
          }.bind(this)
        )
        .error(
          function (error) {
            console.error(error);
          }.bind(this)
        );
    },

    onSearch: function (e) {
      e.preventDefault();
      var searchText = e.target.value.toUpperCase();
      var stores = this.model.get('stores');
      var dropdown = document.getElementById('storeDropdown');
      var options = dropdown.getElementsByClassName('store-option');
      for (var i = 0; i < options.length; i++) {
        var foundStore;
        for (var j = 0; j < stores.length; j++) {
          if (stores[j].location_id == options[i].id) {
            foundStore = stores[j];
            break;
          }
        }
        if (
          foundStore &&
          (foundStore.location_name.toUpperCase().indexOf(searchText) > -1 ||
            foundStore.store_number.toString().indexOf(searchText) > -1)
        ) {
          options[i].style.display = '';
        } else {
          options[i].style.display = 'none';
        }
      }
    },

    closeModal: function (e) {
      if (e) {
        e.preventDefault();
      }
      this.trigger('close');
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

